import React from 'react';
import { Checkbox, CheckboxProps } from '@mui/material';
import { createSvgIcon } from '@mui/material/utils';

import { theme } from '../../../styles/theme';

const AppCheckbox: React.FC<
  Readonly<Omit<CheckboxProps, 'icon' | 'checkedIcon'>>
> = (props) => {
  const boxFillColor = theme.palette.appWhite;
  const checkedColor = theme.palette.questionsForm.formBlue;
  const uncheckedColor = theme.palette.questionsForm.formInputUnselected;

  const CustomUnCheckedIcon = createSvgIcon(
    <rect
      x="2"
      y="2"
      width="20"
      height="20"
      rx="8"
      ry="8"
      fill={boxFillColor}
      stroke={uncheckedColor}
      strokeWidth="1.3"
    />,
    'CustomUnCheckedIcon'
  );

  const CustomCheckedIcon = createSvgIcon(
    <>
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="8"
        ry="8"
        fill={boxFillColor}
        stroke={checkedColor}
        strokeWidth="1.3"
      />
      <path
        d="M7 13l3 3 7-7"
        fill="none"
        stroke={checkedColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>,
    'CustomCheckedIcon'
  );

  return (
    <Checkbox
      {...props}
      icon={<CustomUnCheckedIcon />}
      checkedIcon={<CustomCheckedIcon />}
      disableRipple
      sx={{ padding: '4px' }}
    />
  );
};

export default AppCheckbox;
